import { render, staticRenderFns } from "./Estatistica.vue?vue&type=template&id=56a8668c&scoped=true&"
import script from "./Estatistica.vue?vue&type=script&lang=js&"
export * from "./Estatistica.vue?vue&type=script&lang=js&"
import style0 from "./Estatistica.vue?vue&type=style&index=0&id=56a8668c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a8668c",
  null
  
)

export default component.exports